var Vendor = require('./vendor.js');
var Modules = require('./modules');
var Pages = require('./pages');
var Layout = require('./layout');
var initRecursive = require('./initRecursive.js');

window.Innophos = {
	'Modules': Modules,
	'Pages': Pages,
	'Vendor': Vendor,
	'Layout': Layout,
	'InitRecursive': initRecursive
};

initRecursive(window.Innophos, 'Innophos');
window.InnophosInitiated = true;
